import React from 'react';
import { EarningsApprovedContainer } from '../../../containers';

export const EarningsApproved = () => <EarningsApprovedContainer />;
